import { defineStore } from "pinia";
import axios from '../services/ApiService.js';

export const useCatalogPublicationLibrariesStore = defineStore("CatalogPublicationLibrariesStore", {
  state: () => ({
    data: null,
    loading: false,
  }),
  actions: {
    async fetchCatalogPublicationLibraries(query) {
      this.loading = true;
      try {
        const response = await axios.get(`/api/v1/catalog/libraries?q[name_cont]=${query}`);
        this.data = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading = false;
    }
  }
});
